import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

import {
 
  dispenser1,
  dispenser2,
  dispenser3,
  dispenser4,
  dispenser5,
  dispenser6,
  dispenser7,
  dispenser8,
  dispenser9,
  dispenser10,
  dispenser11,
  dispenser12,
 


} from "../assets/images/index";

const DispenserPrice = () => {
  const products = [
   

          {
            _id:"1101",
            img:dispenser1,
            productName:"DAWLANCE THREE TAP GLASS DOOR WATER DISPENSER Model 1051 GLASS DOOR NOIR RED",
            price:"44100",
            color:"DAWLANCE",
            badge:true,
            des:"The 1051 Glass Door Noir Red With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
        },
          {
            _id:"1102",
            img:dispenser2,
            productName:"DAWLANCE THREE TAPS WATER DISPENSER Model 1051 GLASS DOOR CLOUD WHITE",
            price:"45300",
            color:"DAWLANCE",
            badge:true,
            des:"The 1051 Glass Door Cloud White With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and normal water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
        },
        {
            _id:"1103",
            img:dispenser3,
            productName:"MIDEA THREE TAPS WATER DISPENSER Model YL-2037S BLACK",
            price:"39600",
            color:"MMIDEA",
            badge:true,
            des:"The Midea YL-2037S-B is a user-friendly water dispenser with a sleek design. It offers hot, normal, and cold water options, and is equipped with a refrigerator for added convenience."
        },
          {
            _id:"1104",
            img:dispenser4,
            productName:"PEL TWO TAP WATER DISPENSER Model 525 CURVED GLASSDOOR PURPLE BLAZE",
            price:"37500",
            color:"PEL",
            badge:true,
            des:"The PEL 525 Curved Glassdoor Dispenser is a sleek and efficient water dispenser, designed for modern households. It offers quick cooling and heating, a built-in refrigerator, and a stylish curved glass door. The dispenser is available in multiple colors, adding a touch of elegance to your space."
        },
        {
            _id:"1105",
            img:dispenser5,
            productName:"ORIENT THREE TAP WATER DISPENSER Model CRYSTAL 3 SR",
            price:"38700",
            color:"ORIENT",
            badge:true,
            des:"The Orient Crystal 3 Taps Red Glass Door Water Dispenser is a stylish and functional water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
        },
          {
            _id:"1106",
            img:dispenser6,
            productName:"DAWLANCE THREE TAP WATER DISPENSER Model 1051 BEIGE",
            price:"44100",
            color:"DAWLANCE",
            badge:true,
            des:"The 1051 Glass Door Beige With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
        },
        {
            _id:"1107",
            img:dispenser7,
            productName:"ORIENT THREE TAPS WATER DISPENSER Model ICON 3 TAPS BLACK",
            price:"36300",
            color:"ORIENT",
            badge:true,
            des:"The Icon 3 Taps Black Water Dispenser is a versatile, high-performance water dispenser with a sleek black design. It offers hot, cold, and room temperature water options, ensuring you have access to water at your preferred temperature. This dispenser also features a mini-fridge, providing additional storage space."
        },
          {
            _id:"1108",
            img:dispenser8,
            productName:"ORIENT THREE TAP WATER DISPENSER Model CRYSTAL 3 SP",
            price:"38700",
            color:"ORIENT",
            badge:true,
            des:"The Crystal 3 Taps Purple Glass Door Water Dispenser is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a stylish purple glass door. The child safety lock provides added safety, especially for households with children."
        },
        {
            _id:"1109",
            img:dispenser9,
            productName:"DAWLANCE THREE TAPS WATER DISPENSER Model WD 1051 SILVER",
            price:"44100",
            color:"DAWLANCE",
            badge:true,
            des:"The WD 1051 SILVER is a high-quality water dispenser from Dawlance. It features a sleek design and provides efficient cooling and heating performance. This dispenser offers hot, normal, and cold water options, making it a versatile addition to any home or office."
        },
          {
            _id:"1110",
            img:dispenser10,
            productName:"DAWLANCE THREE TAPS GLASS DOOR WATER DISPENSER Model DBD-1035GD",
            price:"50700",
            color:"DAWLANCE",
            badge:true,
            des:"The DBD-1035 Glass Door Bottom Load Water Dispenser is a high-quality, efficient appliance from Dawlance. It features a sleek glass front design and a bottom load water bottle system for convenience. This dispenser provides hot, cold, and room temperature water options, perfect for any home or office setting."
        },
        {
            _id:"1111",
            img:dispenser11,
            productName:"ORIENT WATER DISPENSER Model ICON 3 MESH GREY",
            price:"36300",
            color:"ORIENT",
            badge:true,
            des:"The Orient Icon 3 Taps Grey Water Dispenser is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
        },
          {
            _id:"1112",
            img:dispenser12,
            productName:"SUPER ASIA THREE TAP WATER DISPENSER Model HC-56BORIENT THREE TAP WATER DISPENSER Model FLARE3 RG",
            price:"37200",
            color:"SUPER ASIA",
            badge:true,
            des:"The HC-56B water dispenser from Super Asia features an elegant tempered double glass door. It offers easy water dispensing with three taps (cold, hot, and normal). The dispenser also includes LED night lights for convenience. With a large stainless steel water tank and a 20-liter refrigerator capacity, it’s a practical addition to any home or office."
        },
        {
          _id:"1101",
          img:dispenser1,
          productName:"DAWLANCE THREE TAP GLASS DOOR WATER DISPENSER Model 1051 GLASS DOOR NOIR RED",
          price:"44100",
          color:"DAWLANCE",
          badge:true,
          des:"The 1051 Glass Door Noir Red With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and room temperature water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
      },
        {
          _id:"1102",
          img:dispenser2,
          productName:"DAWLANCE THREE TAPS WATER DISPENSER Model 1051 GLASS DOOR CLOUD WHITE",
          price:"45300",
          color:"DAWLANCE",
          badge:true,
          des:"The 1051 Glass Door Cloud White With Refrigerator is a high-quality water dispenser designed to meet your daily water consumption needs. It offers hot, cold, and normal water options, and features a built-in refrigerator. The child safety lock provides added safety, especially for households with children."
      },
      {
          _id:"1103",
          img:dispenser3,
          productName:"MIDEA THREE TAPS WATER DISPENSER Model YL-2037S BLACK",
          price:"39600",
          color:"MMIDEA",
          badge:true,
          des:"The Midea YL-2037S-B is a user-friendly water dispenser with a sleek design. It offers hot, normal, and cold water options, and is equipped with a refrigerator for added convenience."
      },
        {
          _id:"1104",
          img:dispenser4,
          productName:"PEL TWO TAP WATER DISPENSER Model 525 CURVED GLASSDOOR PURPLE BLAZE",
          price:"37500",
          color:"PEL",
          badge:true,
          des:"The PEL 525 Curved Glassdoor Dispenser is a sleek and efficient water dispenser, designed for modern households. It offers quick cooling and heating, a built-in refrigerator, and a stylish curved glass door. The dispenser is available in multiple colors, adding a touch of elegance to your space."
      },

     
    
  ];

  const downloadPDF = () => {
    const input = document.getElementById("price-list"); 
    const pdf = new jsPDF("p", "mm", "a4");
    const pageHeight = pdf.internal.pageSize.height;
    const pageWidth = pdf.internal.pageSize.width;
  
    html2canvas(input, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const imgWidth = pageWidth; 
      const imgHeight = (canvas.height * imgWidth) / canvas.width; 
  
      let yPosition = 0;
  
      while (yPosition < imgHeight) {
        pdf.addImage(imgData, "PNG", 0, -yPosition, imgWidth, imgHeight);
        yPosition += pageHeight; 
  
        if (yPosition < imgHeight) {
          pdf.addPage(); 
        }
      }
  
      pdf.save("price-list.pdf");
    });
  };
  return (
    <div className="max-w-container mx-auto px-4">
      <h1 className="text-2xl font-bold mb-5">Dispenser Price List</h1>
      <button
        onClick={downloadPDF}
        className="bg-dark text-white px-4 py-2 mb-5 rounded"
      >
        Download PDF
      </button>
      <div id="price-list" className="space-y-6">
        {products.map((product) => (
          <div
            key={product._id}
            className="flex items-start border rounded shadow p-5"
          >
            <img
              src={product.img}
              alt={product.productName}
              className="w-36 h-36 object-contain mr-5"
            />
            <div>
              <h2 className="text-xl font-semibold">{product.productName}</h2>
              <p className="text-gray-600 mt-2">{product.des}</p>
              <span className="text-lg font-bold mt-2 block">
                Rs.{product.price}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DispenserPrice;
